import { onBeforeMount, onUnmounted, ref, type Ref } from 'vue'

export function useMediaQuery(query: string): Ref<boolean> {
  const abortController = new AbortController()
  const mediaQuery = window.matchMedia(query)

  const isMatching = ref(mediaQuery.matches)

  onBeforeMount(() => {
    mediaQuery.addEventListener(
      'change',
      () => {
        isMatching.value = mediaQuery.matches
      },
      { signal: abortController.signal }
    )
  })

  onUnmounted(() => {
    abortController.abort()
  })

  return isMatching
}
